import { useRef } from 'react'
import { useIsSpeaking, VideoTrack } from '@livekit/components-react'

import type { TrackReference } from '@livekit/components-react'
import type { Participant } from 'livekit-client'

import { asReact17 } from './reactCompat'
import { useVideoObjectFit } from './useVideoObjectFit'
import styles from './medentee.module.css'

const Video = asReact17(VideoTrack)

export type ParticipantTileProps = {
  participant: Participant
  track?: TrackReference
}

export const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join('') || '?'

export function ParticipantTile({ participant, track }: ParticipantTileProps) {
  const isSpeaking = useIsSpeaking(participant)
  const name = participant.name || participant.identity

  const tileRef = useRef<HTMLDivElement>(null)
  const objectFit = useVideoObjectFit(tileRef, track?.publication?.trackSid)

  return (
    <div ref={tileRef} className={`${styles.tileInner} ${isSpeaking ? styles.speaking : ''}`}>
      {track ? (
        <Video
          trackRef={track}
          style={{ objectFit }}
          className={`${styles.video} ${participant.isLocal ? styles.mirrored : ''}`}
        />
      ) : (
        <div className={styles.avatar}>{initialsOf(name)}</div>
      )}
      <span className={styles.tileName}>{name}</span>
    </div>
  )
}
